import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash } from "@phosphor-icons/react";
import api, { formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export default function AnnouncementsAdmin() {
  const [items, setItems] = useState([]);
  const [scheduled, setScheduled] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", scheduled_at: "", send_push: true });

  const load = async () => {
    const [a, s] = await Promise.all([api.get("/announcements"), api.get("/announcements/scheduled")]);
    setItems(a.data); setScheduled(s.data);
  };
  useEffect(() => { load(); }, []);

  const submit = async () => {
    try {
      const payload = { ...form };
      if (!payload.scheduled_at) delete payload.scheduled_at;
      else payload.scheduled_at = new Date(payload.scheduled_at).toISOString();
      await api.post("/announcements", payload);
      toast.success(payload.scheduled_at ? "Scheduled" : "Sent"); setForm({ title: "", body: "", scheduled_at: "", send_push: true }); load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const testPush = async () => {
    try { const { data } = await api.post("/push/test"); toast.success(`Sent ${data.sent}, failed ${data.failed}`); }
    catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div>
      <div className="p-4 bg-[#FFFFFF] border border-[#E5E9F0] rounded-sm space-y-3 mb-4">
        <Input placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="rounded-sm" data-testid="admin-announcement-title" />
        <Textarea placeholder="Body" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} rows={3} className="rounded-sm" data-testid="admin-announcement-body" />
        <div className="flex gap-2 items-center">
          <Input type="datetime-local" value={form.scheduled_at} onChange={(e) => setForm({ ...form, scheduled_at: e.target.value })} className="rounded-sm flex-1" data-testid="admin-announcement-schedule" />
          <label className="flex items-center gap-2 text-xs text-[#5a5a5a]">
            <input type="checkbox" checked={form.send_push} onChange={(e) => setForm({ ...form, send_push: e.target.checked })} /> send push
          </label>
        </div>
        <div className="flex gap-2">
          <Button onClick={submit} className="rounded-sm bg-[#000000] text-[#FFFFFF] hover:bg-[#1c1c24]" data-testid="admin-announcement-send">{form.scheduled_at ? "Schedule" : "Send now"}</Button>
          <Button variant="outline" onClick={testPush} className="rounded-sm" data-testid="admin-test-push">Test push</Button>
        </div>
      </div>

      {scheduled.length > 0 && (
        <>
          <h3 className="font-mono-time text-xs uppercase tracking-widest text-[#7A828C] mb-2">Scheduled</h3>
          <div className="space-y-2 mb-4">
            {scheduled.map((a) => (
              <div key={a.id} className="p-3 bg-[#FFFFFF] border border-[#E5E9F0] rounded-sm flex justify-between items-center">
                <div><div className="font-medium">{a.title}</div><div className="text-xs text-[#7A828C]">@ {new Date(a.scheduled_at).toLocaleString()}</div></div>
                <button onClick={async () => { await api.delete(`/announcements/${a.id}`); load(); }} className="w-10 h-10 grid place-items-center rounded-sm text-red-400 hover:bg-[#F0F2F7]"><Trash size={16} /></button>
              </div>
            ))}
          </div>
        </>
      )}

      <h3 className="font-mono-time text-xs uppercase tracking-widest text-[#7A828C] mb-2">Sent</h3>
      <div className="space-y-2">
        {items.map((a) => (
          <div key={a.id} className="p-3 bg-[#FFFFFF] border border-[#E5E9F0] rounded-sm flex justify-between items-start gap-2">
            <div className="flex-1"><div className="font-medium">{a.title}</div><div className="text-xs text-[#7A828C]">{new Date(a.sent_at).toLocaleString()}</div><div className="text-sm text-[#5a5a5a] mt-1">{a.body}</div></div>
            <button onClick={async () => { await api.delete(`/announcements/${a.id}`); load(); }} className="w-10 h-10 grid place-items-center rounded-sm text-red-400 hover:bg-[#F0F2F7]"><Trash size={16} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
